/**
 * socialButtons
 */
export function socialButtons() {
  const socialBlock = document.querySelector('.social-buttons');
  if (socialBlock) {
    const shareConfig = {
      facebook: 'https://www.facebook.com/sharer/sharer.php?u={url}',
      twitter: 'https://twitter.com/intent/tweet?text={text}+({url})',
      vk: 'https://vk.com/share.php?url={url}',
      telegram: 'https://t.me/share/url?url={url}&title={text}',
    };

    const socialBlockUrl = encodeURIComponent(
        socialBlock.getAttribute('data-social-link'));
    const socialBlockTitle = encodeURIComponent(
        socialBlock.getAttribute('data-social-title'));
    [].map.call(document.querySelectorAll('.social-buttons__button'),
        function(btn) {
          btn.addEventListener('click', function() {
            const type = btn.getAttribute('data-social');
            const windowLink = shareConfig[type].
                replace('{url}', socialBlockUrl).
                replace('{text}', socialBlockTitle);
            window.open(windowLink, `Опубликовать ссылку в {$type}`,
                'width=640,height=436,toolbar=0,status=0');
          });
        });
  }
}

/**
 * favoriteButton
 */
export function favoriteButton() {
  const socialBlock = document.querySelector('.social-buttons__favorite');
  if (socialBlock) {
    socialBlock.addEventListener('click', function() {
      alert('Нажмите Ctrl-D, чтобы добавить страницу в закладки');
    });
  }
}

/**
 * upButton
 * @param {number} scrollHeight
 */
export function upButton(scrollHeight = 100) {
  const upButton = document.querySelector('.button-up');
  if (upButton) {
    showScrollButton(upButton, scrollHeight);

    window.addEventListener('scroll', function() {
      showScrollButton(upButton, scrollHeight);
    });

    upButton.addEventListener('click', function() {
      const scrollTop = window.pageYOffset ||
        document.documentElement.scrollTop;
      if (scrollTop > scrollHeight) {
        window.scrollTo(0, 0);
      }
    });
  }
}

/**
 * showScrollButton
 * @param {object} upButton
 * @param {number} scrollHeight
 */
function showScrollButton(upButton, scrollHeight) {
  const scrollTop = window.pageYOffset ||
    document.documentElement.scrollTop;
  if (scrollTop > scrollHeight) {
    upButton.classList.add('button-up--show');
  } else {
    upButton.classList.remove('button-up--show');
  }
}
